import React from 'react';
import _ from 'lodash';
import ReactTooltip from 'react-tooltip';
import { reduxForm } from 'redux-form';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

import Button from '../../common/Button';

const renderPeople = (people, t) => {
  if (people.length === 0) {
    return <strong>{t('general.doraName')}</strong>;
  }

  if (people.length === 1) {
    const person = people[0];
    return (
      <Link to={`/users/${person._id}`} className="u-color-blue-violet">
        <strong>{person.name}</strong>
      </Link>
    );
  }

  if (people.length === 2) {
    return people
      .map((person) => (
        <Link
          key={person._id}
          to={`/users/${person._id}`}
          className="u-color-blue-violet"
        >
          <strong>{person.name}</strong>
        </Link>
      ))
      .reduce((prev, curr) => [prev, ` ${t('general.and')} `, curr]);
  }

  const samplePeople = _.take(people, 2)
    .map((person) => (
      <Link
        key={person._id}
        to={`/users/${person._id}`}
        className="u-color-blue-violet"
      >
        <strong>{person.name}</strong>
      </Link>
    ))
    .reduce((prev, curr) => [prev, ', ', curr]);

  return (
    <React.Fragment>
      {samplePeople} {t('project.memo.thanksButtonAndMore')}{' '}
      <span
        className="u-color-blue-violet u-cursor-pointer"
        data-tip={_.takeRight(people, people.length - 2)
          .map((p) => p.name)
          .join(', ')}
        data-for="likes-counter"
      >
        {people.length - 2}{' '}
        {t('project.memo.thanksButtonUsers', {
          postProcess: 'interval',
          count: people.length - 2,
        })}
      </span>
    </React.Fragment>
  );
};

const displayLoading = (memo, currentUserId, t, type) => {
  if (memo.thanksReceivedFrom.map((th) => th._id).includes(currentUserId)) {
    const cases = {
      PROJECT: t('project.memo.cancelThanks'),
      GOAL: t('goal.memo.cancelThanks'),
    };
    return cases[type];
  }

  const cases = {
    PROJECT: t('project.memo.submitThanks'),
    GOAL: t('goal.memo.submitThanks'),
  };
  return cases[type];
};

let Form = ({
  handleSubmit,
  onSubmit,
  submitting,
  error,
  okButtonText,
  t,
  memo,
  currentUserId,
  isCurrentlyLoggedInUserMemo,
  type,
}) => (
  <form
    onSubmit={handleSubmit}
    className="u-display-flex u-align-items-center u-padding-top u-margin-top-tiny u-border-top"
  >
    <Button
      type="submit"
      styleType={type === 'PROJECT' ? 'thumbsup' : 'clap'}
      className={`
        ${
          memo.thanksReceivedFrom.map((t) => t._id).includes(currentUserId) ||
          submitting
            ? 'active'
            : ''
        }
        ${isCurrentlyLoggedInUserMemo ? 'disabled' : ''}
        `}
      onClick={this.incrementLikes}
      disabled={isCurrentlyLoggedInUserMemo || submitting}
    />
    <div className="c-btn--thumbsup__counter u-margin-left-tiny u-weight-light">
      {submitting ? (
        displayLoading(memo, currentUserId, t, type)
      ) : (
        <React.Fragment>
          {renderPeople(memo.thanksReceivedFrom, t)}

          {t(
            `${type === 'PROJECT' ? 'project' : 'goal'}.memo.thanksButtonText`,
            {
              postProcess: 'interval',
              count:
                memo.thanksReceivedFrom.length === 0
                  ? 1
                  : memo.thanksReceivedFrom.length,
            }
          )}
        </React.Fragment>
      )}
    </div>
    <ReactTooltip
      id="likes-counter"
      effect="float"
      className="c-tooltip--secondary"
    />
  </form>
);

Form = reduxForm()(translate()(Form));

export default Form;



// WEBPACK FOOTER //
// ./src/memos/send-thanks/Form.js